<div class="controls-container">
    <div class="controls-header">Panels</div>

    <div class="controls-sub-header">Stack Panel</div>

    <pm-stack-panel>
        <div [style.padding-right.px]="10">Item 1</div>
        <div [style.padding-right.px]="10">Item 2</div>
        <div [style.padding-right.px]="10">Item 3</div>
        <div class="flex-align-right" [style.padding-right.px]="10">Item 3</div>
    </pm-stack-panel>

    <div class="controls-sub-header">Form Panel</div>

    <pm-form-panel>
        <pm-form>
        </pm-form>
    </pm-form-panel>

    <div class="controls-sub-header">Grid Panel</div>

    <pm-grid-panel HeightPx="200" WidthPx="300">
        <div class="control-center" 
             [style.background-color]="'#e9ecef'" 
             [style.width]="'100%'">Grid Panel</div>
    </pm-grid-panel>

    <div class="controls-sub-header">Resize Panel</div>

    <pm-resize-panel HeightPx="200"
                     Orientation="Horizontal"
                     FirstElementFlexGrow=".3"
                     SecondElementFlexGrow=".7">
        <div class="layout-left-panel control-center" 
             resize-item-1
             [style.background-color]="'#e9ecef'"             
             [style.height]="'100%'">
             <div>Left Panel</div>
        </div>
        <div class="layout-right-view control-center" 
            resize-item-2
            [style.color]="'white'"
            [style.background-color]="'#1E88E5'"
            [style.height]="'100%'">
            <div>Right Panel</div>
        </div>
    </pm-resize-panel>

    <pm-resize-panel HeightPx="200"        
        FirstElementFlexGrow=".3"
        SecondElementFlexGrow=".7"
        CustomThumbClass="black-thumb-ns">
        <div class="layout-left-panel control-center" 
        resize-item-1
        [style.background-color]="'#e9ecef'"             
        [style.height]="'100%'">
        <div>Left Panel (custom thumb style)</div>
        </div>
        <div class="layout-right-view control-center" 
        resize-item-2
        [style.color]="'white'"
        [style.background-color]="'#1E88E5'"
        [style.height]="'100%'">
        <div>Right Panel</div>
        </div>
    </pm-resize-panel>

    <div class="controls-sub-header">Overlay Panel</div>

    <div [style.height.px]="200" [style.width.px]="300">
        <pm-overlay>
            <div style="font-style:oblique;">Please make a selection...</div>
        </pm-overlay>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/panels/panels.html